import { render, staticRenderFns } from "./RelatoriosEAD.vue?vue&type=template&id=1744d21a&scoped=true&"
import script from "./RelatoriosEAD.vue?vue&type=script&lang=js&"
export * from "./RelatoriosEAD.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosEAD.vue?vue&type=style&index=0&id=1744d21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744d21a",
  null
  
)

export default component.exports